import * as types from '../mutation-types';
import {UpdateAccountsBalancses} from '../data-reformer.js'
const state = {
    accountStatement: {},
	account_statement_summary: {},
	trial_balance: {},
	account_custom_statement: {},
	journal: {},
	final_account: {},
	box_balance: {},
	matchedEntries: [],
	statistics: {},
	inventory: {},
	material_statement: {},
	salesStatement: [], 
	advanceStatement: []
}

const actions = {
	fetchAccountStatementSummary({ commit }, { accountId }) {
		return window.axios.get(`Accounting/Statements/Account/${accountId}/Summary`).then(response => {
            commit(types.STORE_ACCOUNT_STATEMENT_SUMMARY, response.data)
            return response.data
		})
	},

	fetchAccountStatement({ commit }, { accountId, start_date, end_date, keywords, includes_previous_balance }) {
		return window.axios.get(`Accounting/Statements/Account/${accountId}/Detailed`, {
            params: {
				accountId: accountId,
				startDate: start_date,
				endDate: end_date,
				keywords,
				includesPreviousBalance: includes_previous_balance
			}
        }).then(response => {
			commit(types.STORE_ACCOUNT_STATEMENT, response.data)
			return response.data;
		})
	},
	fetchMaterialStatement({ commit }, { material_id, from_date, to_date }) {
		return window.axios.get(`Accounting/Statements/Materials/${material_id}`, {
            params: {
				materialId: material_id,
				fromDate: from_date, 
				toDate: to_date
			}
        }).then(response => {
			commit(types.STORE_MATERIAL_STATEMENT, response.data)
			return response.data;
		})
	},

	fetchAccountCustomStatement({ commit }, { custom_statement_id, show_non_zero_accounts_only }) {
		return window.axios.get(`Accounting/Statements/Custom/${custom_statement_id}`,{
			params: { 
				showNonZeroAccountsOnly: show_non_zero_accounts_only 
			}
		}).then(response => {
			commit(types.STORE_ACCOUNT_CUSTOM_STATEMENT, response.data)
			return response.data;
		})
	},
	createTrialBalance({ commit }, { account_id, show_parent_accounts, show_non_zero_accounts_only, from_accounting_no, to_accounting_no }) {
		return window.axios.get(`Accounting/TrialBalance`,{
			params: {
				accountId: account_id,
				showParentAccounts: show_parent_accounts,
				showNonZeroAccountsOnly: show_non_zero_accounts_only,
				fromAccountingNo: from_accounting_no,
				toAccountingNo: to_accounting_no
			}
		}).then(response => {
			commit(types.STORE_TRIAL_BALANCE, response.data)
			return response.data;
		})
	},
	fetchJournalTable({ commit }, { start_date, end_date, keywords, only_debit_entries }) {
		return window.axios.get(`Accounting/JournalTable`,{
			params: {
				startDate: start_date,
				endDate: end_date,
				keywords,
				onlyDebitEntries: only_debit_entries
			}
		}).then(response => {
			commit(types.STORE_JOURNAL, response.data);
			return response.data;
		});
	},
	fetchOperationsFinalAccounts({ commit }) {
		return window.axios.get(`Accounting/FinalAccounts/Operations`).then(response => {
			commit(types.STORE_FINAL_ACCOUNT, response.data);
			return response.data;
		});
	},
	fetchTradeFinalAccount({ commit }) {
		return window.axios.get(`Accounting/FinalAccounts/Trade`).then(response => {
			commit(types.STORE_FINAL_ACCOUNT, response.data);
			return response.data;
		});
	},
	fetchGainsAndLossesFinalAccount({ commit }) {
		return window.axios.get(`Accounting/FinalAccounts/GainsAndLosses`).then(response => {
			commit(types.STORE_FINAL_ACCOUNT, response.data);
			return response.data;
		});
	},
	fetchBudgetFinalAccount({ commit }) {
		return window.axios.get(`Accounting/FinalAccounts/Budget`).then(response => {
			commit(types.STORE_FINAL_ACCOUNT, response.data);
			return response.data;
		});
	},
	CloseAccounts({ commit }, {selectedAccountId}) {
		return window.axios.put(`Accounting/FinalAccounts/CloseAccounts/${selectedAccountId}`).then(response => {
			commit('', '')
			return response.data;
		});
	},
	fetchBoxBalance({ commit }) {
		return window.axios.get(`Accounting/BoxBalance`).then(response => {
			commit(types.STORE_BOX_BALANCE, response.data);
			return response.data;
		});
	},
	UncloseAccounts({ commit }) {
		return window.axios.put(`Accounting/FinalAccounts/UncloseAccounts`).then(response => {
			commit('', '')
			return response.data;
		});
	},
	ChangeMatching({ commit }, { bondType, bondId, entryId, matching }) {
		return window.axios.put(`FundsFlow/Bonds/${bondType}/${bondId}/Entries/${entryId}/ChangeMatching/${matching}`).then(response => {
			commit(types.STORE_ONE_ADVANCED_ENTRY, response.data);
			return response.data;
		});
	},
	fetchMatchedEntries({ commit }, accountId ) {
		return window.axios.get(`Accounting/Statements/Account/${accountId}/MatchingTable`).then(response => {
			commit(types.STORE_MATCHED_ENTRIES, response.data);
			return response.data;
		});
	},
	fetchStatistics({ commit }) {
		return window.axios.get(`Accounting/Statistics`).then(response => {
			commit(types.STORE_STATISTICS, response.data);
			return response.data;
		});
	},
	createInventoryReport({ commit }, { warehouse_id, material_id, with_primary_materials, where_materials_have_balances, materialDeliveryStatus }) {
		return window.axios.get(`Accounting/InventoryReport`,{
			params: {
				warehouseId: warehouse_id,
				materialId: material_id,
				withPrimaryMaterials: with_primary_materials,
				whereMaterialsHaveBalances: where_materials_have_balances,
				materialDeliveryStatus: materialDeliveryStatus
			}
		}).then(response => {
			commit(types.STORE_INVENTORY_REPORT, response.data)
			return response.data;
		})
	},

	fetchSalesStatements({ commit }, { materialId, clientId, fromDate, toDate, transactionType } = {}) {
		return window.axios.get('MaterialFlow/MaterialsJournals/SalesStatementReport', {
			params: { sortType: 'Descending', materialId, clientId, fromDate, toDate, transactionType }
		}).then(({ data }) => {
			commit(types.STORE_SALES_STATEMENT, data);
			return data;
		})
	},

	clear({ commit }) {
		commit(types.CLEAR);
	},

	fetchStatementAdvance({ commit }, { accountId, startDate, endDate, keywords }) {
		return window.axios.get(`Accounting/Statements/Account/${accountId}/LedgerStatement`, { 
			params: { startDate, endDate, keywords } 
		}).then(({ data }) => {
			commit(types.STORE_STATEMENT_ADVANCE, data)
			return data
		})
	},

	fetchBoxBalanceByNo(_, { bondNo }) {
		return window.axios.get(`accounting/boxBalance/${bondNo}`).then((data) => {
			return data
		})
	}
}

const mutations = {
	[types.STORE_ACCOUNT_STATEMENT_SUMMARY](state, account_statement_summary) {
		state.account_statement_summary = account_statement_summary;
    },
	[types.STORE_MATERIAL_STATEMENT](state, material_statement) {
		state.material_statement = material_statement;
    },
    [types.STORE_ACCOUNT_STATEMENT](state, account_statement) {
		state.accountStatement = account_statement;
	},
	[types.STORE_ACCOUNT_CUSTOM_STATEMENT](state, account_custom_statement) {
		state.account_custom_statement = account_custom_statement;
	},
	[types.STORE_TRIAL_BALANCE](state, trial_balance) {
		state.trial_balance = trial_balance
	},
	[types.STORE_JOURNAL](state, journal) {
		state.journal = journal;
	},
	[types.STORE_FINAL_ACCOUNT](state, final_account) {
		state.final_account = final_account;
	},
	[types.STORE_BOX_BALANCE](state, box_balance) {
		state.box_balance = box_balance;
	},
	[types.STORE_ONE_ADVANCED_ENTRY](state, entry) {
		state.accountStatement.advanced_entries.find(c => c.id === entry.id).is_matched = entry.is_matched
	},
	[types.STORE_MATCHED_ENTRIES](state, matchedEntries) {
		state.matchedEntries = matchedEntries;
	},
	[types.STORE_STATISTICS](state, statistics) {
		state.statistics = statistics;
		UpdateAccountsBalancses(statistics.balances)
	},
	[types.STORE_INVENTORY_REPORT](state, inventory) {
		state.inventory = inventory
	},
	[types.STORE_SALES_STATEMENT](state, salesStatement) {
		state.salesStatement = salesStatement
	},
	[types.CLEAR](state) {
		state.account_custom_statement = {}
		state.inventory = {}
		state.material_statement = {}
		state.salesStatement = []
	},
	[types.STORE_STATEMENT_ADVANCE](state, advanceStatement) {
		state.advanceStatement = advanceStatement
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}

